import { DynamicNumberSchema, DynamicStringSchema } from '@a2ui/web_core/v0_9';
import { createComponentImplementation } from '@a2ui/react/v0_9';
import { defineA2uiComponentSchema } from '../../a2ui-schema';
import { RiskScoreCard } from './RiskScoreCard';

interface ResolvedProps {
  readonly score: number;
  readonly label: string;
  readonly context?: string;
  readonly trend?: string;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const schema = defineA2uiComponentSchema({
  score: DynamicNumberSchema,
  label: DynamicStringSchema,
  context: DynamicStringSchema,
  trend: DynamicStringSchema,
}) as any;

export const RiskScoreCardImpl = createComponentImplementation(
  { name: 'RiskScoreCard', schema },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ({ props }: { props: ResolvedProps; buildChild: any; context: any }) => (
    <RiskScoreCard
      score={props.score ?? 0}
      label={props.label ?? ''}
      context={props.context}
      trend={props.trend as 'up' | 'down' | 'flat' | undefined}
    />
  )
);
